/**
 * Countdown Module – ticks down to the ISO date in [data-countdown-end]
 */
document.addEventListener('DOMContentLoaded', function () {
  var DAY = 86400;
  var HOUR = 3600;
  var MINUTE = 60;

  document.querySelectorAll('.countdown[data-countdown-end]').forEach(function (el) {
    var end = Date.parse(el.dataset.countdownEnd);
    if (isNaN(end)) return;

    var nodes = {};
    el.querySelectorAll('[data-countdown-unit]').forEach(function (node) {
      nodes[node.dataset.countdownUnit] = node;
    });

    var timer = null;

    function set(key, value) {
      if (nodes[key] && nodes[key].textContent !== String(value)) {
        nodes[key].textContent = value;
      }
    }

    function tick() {
      var remaining = Math.max(0, Math.floor((end - Date.now()) / 1000));

      set('days', Math.floor(remaining / DAY));
      set('hours', Math.floor((remaining % DAY) / HOUR));
      set('minutes', Math.floor((remaining % HOUR) / MINUTE));
      set('seconds', remaining % MINUTE);

      if (remaining === 0) {
        el.classList.add('is-complete');
        if (timer) clearInterval(timer);
        return false;
      }
      return true;
    }

    if (tick()) {
      timer = setInterval(tick, 1000);
    }
  });
});
